import * as mod from 'common-ui/lib/common/CommonElements/Button';

export default mod.default;
